module.exports = __webpack_public_path__ + "static/media/project3.c8b49f5d.png";